import React from 'react';
interface ScrollHintTableProps {
  children: React.ReactNode;
  minWidth?: string;
}
export function ScrollHintTable({
  children,
  minWidth = '560px'
}: ScrollHintTableProps) {
  return <div data-id="element-367" data-mp="1i7eim9hxx1bw">
      <p className="mb-2 text-center text-xs font-medium text-muted sm:hidden" data-id="element-368" data-mp="1i6wgiw8ljsw2">
        ← Desliza para ver la tabla completa →
      </p>
      <div className="scrollbar-hide overflow-x-auto rounded-2xl border border-white/10" data-id="element-369" data-mp="1mzfwu0yo524k">
        <div style={{
        minWidth
      }} data-id="element-370" data-mp="1rwg0y6byjut1">{children}</div>
      </div>
    </div>;
}